import {SortOrder} from "../sort-order";

export class ApplicationFilters {
  code: string;
  sortField: string;
  sortOrder: SortOrder;

  public getOrder(){
    return this.sortOrder?.valueOf() ? 'desc' : 'asc';
  }
}
